export default {
    state: {
        selectedPrintable: {}, // Currently selected printable
    },
    mutations: {
        setSelectedPrintable(state, printable) {
            state.selectedPrintable = printable;
        },
    },
    actions: {
        
    },
    getters: {
        selectedPrintable: (state) => state.selectedPrintable,
    },
};
